const json = {
    GE: {
        SHARE: 'გაზიარება'
    },
    EN: {
        SHARE: 'Share'
    }
}

export default json



// WEBPACK FOOTER //
// ./client/app/common/mcactionbutton/mcactionbutton.texts.js